import Instruction from "@/pages/Topup/sections/Instruction"
import Status from "@/pages/Topup/sections/Status"
import { DepositType } from "@usher/pe-client-front-end-lib"
import { Route, Switch, useRouteMatch } from "react-router-dom"
import { SelectPayment } from "./pages/SelectPayment"

export const OrderIban = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route path={path} exact component={SelectPayment} />
      <Route path={`${path}/instructions`}>
        <Instruction depositType={DepositType.IBAN} withSendHash={false} isOrder />
      </Route>
      <Route path={`${path}/status/:token`}>
        <Status depositType={DepositType.IBAN} isOrder />
      </Route>
    </Switch>
  )
}
